// extracted by mini-css-extract-plugin
export default {"container":"Inset--container--0ivPm","transparent":"Inset--transparent--TymDJ"};